import { useMemo, useState } from 'react';

import { Grid, Box, Heading, Text, useTheme } from '@simplywallst/ui-core';
import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';

import useLegacyPortfolios from '../../hooks/useLegacyPortfolios/useLegacyportfolios';

import { UserPortfolioTile } from './UserPortfolioTile';
import { InformationModal } from './InformationModal';

export const LegacyPortfolios = () => {
  const theme = useTheme();
  const [showInformationModal, setShowInformationModal] = useState(false);

  const {
    entities: legacyPortfoliosEntities,
    keys: legacyPortfoliosKeys,
    isFetched: isLegacyPortfoliosFetched,
    isFetching: isLegacyPortfoliosFetching,
  } = useLegacyPortfolios();

  const portfolios = Object.entries(legacyPortfoliosEntities || {});

  const sortedPortfolios = useMemo(
    () =>
      portfolios.sort(
        ([, a], [, b]) =>
          new Date(a.formattedDateGenerated).getTime() -
          new Date(b.formattedDateGenerated).getTime()
      ),
    [portfolios]
  );

  if (isLegacyPortfoliosFetching || !isLegacyPortfoliosFetched) return null;
  if (isLegacyPortfoliosFetched && legacyPortfoliosKeys.length === 0)
    return null;

  return (
    <Box
      data-cy-id="legacy-portfolios-section"
      marginY="x0"
      marginXLg="x0"
      marginX="x2"
    >
      <Grid templateRows="repeat(3, auto)" gap="12px">
        <Grid
          templateColumns="repeat(2, max-content)"
          alignItems="center"
          gap="4px"
        >
          <Heading as="h3" typography="baseStrong">
            Legacy Portfolios
          </Heading>
          <Grid
            templateRows="24px"
            templateColumns="24px"
            backgroundColor="phantom"
            borderRadius="x2"
            justifyItems="center"
            alignItems="center"
          >
            <Text typography="xSmall">{portfolios.length}</Text>
          </Grid>
        </Grid>
        <Grid
          templateColumns="max-content min-content"
          templateRows="24px"
          alignItems="center"
          gap="4px"
        >
          <Text typography="xSmall" color="whiteRGBA" opacity={0.5}>
            Not included in aggregated performance
          </Text>
          <button
            onClick={() => setShowInformationModal(true)}
            data-cy-id="legacy-portfolio-info-icon"
          >
            <InformationSolid fill={theme.color.whiteRGBA(0.5)} />
          </button>
          {showInformationModal && (
            <InformationModal onClose={() => setShowInformationModal(false)} />
          )}
        </Grid>
        <Grid
          gap="24px"
          templateRows="auto"
          templateColumnsSm="repeat(4, 1fr)"
          templateColumns="repeat(2, 1fr)"
          justifyContent="space-between"
        >
          {sortedPortfolios.map(([key, portfolio], index) => (
            <UserPortfolioTile index={index} portfolio={portfolio} key={key} />
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};
